/* PUNIVERSE build — product page behaviour.
   Replaces four small pieces of React from the preview: gallery swap, sticky buy bar,
   paginated review wall, and a real add-to-cart. Loaded only on product templates.

   Everything here is progressive: with JS off the gallery shows the first shot, every review is
   visible and the add-to-bag form posts to /cart the normal way. */
(function () {
  /* ---- gallery: click a thumb to swap the stage ---- */
  var gallery = document.querySelector("[data-ge-gallery]");
  if (gallery) {
    var stage = gallery.querySelector("[data-ge-stage]");
    gallery.addEventListener("click", function (e) {
      var thumb = e.target.closest(".pdp__thumb");
      if (!thumb || !stage) return;
      stage.src = thumb.dataset.src;
      stage.alt = thumb.dataset.alt || "";
      gallery.querySelectorAll(".pdp__thumb").forEach(function (t) {
        t.classList.toggle("is-active", t === thumb);
      });
    });
  }

  /* ---- sticky buy bar: appears once the buy box has scrolled away ---- */
  var sticky = document.querySelector("[data-ge-sticky]");
  if (sticky) {
    var onScroll = function () {
      sticky.classList.toggle("is-shown", window.scrollY > 680);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  /* ---- review wall: show the first N, reveal the rest in pages ---- */
  var wall = document.querySelector("[data-ge-reviews]");
  var moreWrap = document.querySelector("[data-ge-reviews-more]");
  if (wall && moreWrap) {
    var page = parseInt(wall.dataset.page, 10) || 3;
    var items = Array.prototype.slice.call(wall.children);
    var shown = page;
    var paint = function () {
      items.forEach(function (el, i) {
        el.hidden = i >= shown;
      });
      moreWrap.hidden = shown >= items.length;
    };
    moreWrap.querySelector("button").addEventListener("click", function () {
      shown += page;
      paint();
    });
    paint();
  }

  /* ---- add to bag: keep the customer on the page, update the header count ----
     The form's native POST is the fallback, so a fetch failure re-submits normally. */
  var count = document.querySelector("[data-ge-bag-count]");
  document.querySelectorAll("form[data-ge-add]").forEach(function (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var btn = form.querySelector("[data-ge-add-btn]");
      var label = btn ? btn.textContent : "";
      if (btn) btn.disabled = true;
      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
          items: [{ id: form.querySelector('[name="id"]').value, quantity: 1 }],
        }),
      })
        .then(function (r) {
          if (!r.ok) throw new Error("add failed");
          return fetch(window.Shopify.routes.root + "cart.js");
        })
        .then(function (r) {
          return r.json();
        })
        .then(function (cart) {
          if (count) {
            count.textContent = cart.item_count;
            count.classList.toggle("is-empty", cart.item_count === 0);
          }
          if (btn) {
            btn.textContent = "Added to bag ✓";
            btn.disabled = false;
            setTimeout(function () {
              btn.textContent = label;
            }, 2400);
          }
        })
        .catch(function () {
          form.submit();
        });
    });
  });
})();
